"use client"

import {useAxios} from "../../../../hooks/useAxios";

export const  handleQuiz = (item) =>{

    const {post} = useAxios()
    let antwoord = ''
    const antwoorden = Array.from(document.getElementsByClassName('answer'))
    const vraag = document.getElementsByClassName('question')
    const goedAntwoordElement = document.getElementById('goedAntwoord')
    const foutAntwoordElement = document.getElementById('foutAntwoord')
    const vraagCheckButton = document.getElementsByClassName('vraag_check')
    const volgendeVraagButton = document.getElementsByClassName('volgendeVraag')

    if (vraag.length === 0 || antwoorden.length === 0 || vraagCheckButton.length === 0 || volgendeVraagButton.length === 0 || !foutAntwoordElement || !goedAntwoordElement) return

    const submitAntwoord = (antwoord, goedAntwoordElement, foutAntwoordElement, volgendeVraagButton, vraagCheckButton, vraag) => {
        const juistAntwoord = antwoord.hasAttribute('data-antwoord')

        const data = {
            'handeling': 'Quiz',
            'url': window.location.href,
            'naam': vraag,
            'wiki_item_id': item.id,
            'extra': {
                'value': antwoord.value,
                'antwoord': juistAntwoord ? 'goed' : 'fout',
            }
        }

        post('/log', data)

        if (juistAntwoord) {
            goedAntwoordElement.style.display = 'block'
            foutAntwoordElement.style.display = 'none'
            volgendeVraagButton.style.display = 'block'
            vraagCheckButton.style.display = 'none'
        } else {
            goedAntwoordElement.style.display = 'none'
            foutAntwoordElement.style.display = 'block'
            volgendeVraagButton.style.display = 'none'
        }
    }

    antwoorden.forEach(vraag => {

        vraag.addEventListener('change', (e) => {

            antwoorden.forEach(x => {
                x.checked = false
                return x
            })
            goedAntwoordElement.style.display = 'none'
            foutAntwoordElement.style.display = 'none'
            volgendeVraagButton[0].style.display = 'none'
            vraagCheckButton[0].style.display = 'block'
            e.target.checked = true

            antwoord = e.target
        })
    })

    vraagCheckButton[0].addEventListener('click', () => {
        submitAntwoord(antwoord, goedAntwoordElement, foutAntwoordElement, volgendeVraagButton[0], vraagCheckButton[0])
    })

    return () => {
        antwoorden.forEach(vraag => {
            vraag.removeEventListener('change', (e) => {
                goedAntwoordElement.style.display = 'none'
                foutAntwoordElement.style.display = 'none'
                volgendeVraagButton[0].style.display = 'none'
                vraagCheckButton[0].style.display = 'block'

                antwoord = e.target
            })
        })
        vraagCheckButton[0].removeEventListener('click', () => {
            submitAntwoord(antwoord, goedAntwoordElement, foutAntwoordElement, volgendeVraagButton[0], vraagCheckButton[0], vraag[0])
        })
    }
}